import type { CartItemMinimal } from '@jane/bloom/types/schemas/bloom/checkout';
import type { CartProductMinimal } from '@jane/bloom/types/schemas/marketplace/cart';

export const mergeCartItem = (
  newCartItem: {
    count: number;
    price_id: string;
    product_id: number;
  },
  cartItems: CartItemMinimal[]
): CartProductMinimal[] => {
  const cartProducts = cartItems.map((item) => ({
    count: item.count,
    price_id: item.priceId,
    product_id: Number(item.productId),
  }));

  const existingItem = cartProducts.find((item) => {
    return (
      item.product_id === newCartItem.product_id &&
      item.price_id === newCartItem.price_id
    );
  });

  if (existingItem) {
    existingItem.count = newCartItem.count;
  } else {
    cartProducts.push(newCartItem);
  }

  return cartProducts;
};
